export default "__VITE_ASSET__87fa1589__"